import { useCallback, useRef, useState } from 'react';
import { rmsApi } from '../../state/axios';

type Params = {
  onSuccess?(data?: any): void;
};

const useFetchCompanyData = ({ onSuccess }: Params) => {
  const [companyData, setCompanyData] = useState<any>(null);
  const [isCompanyDataLoading, setIsCompanyDataLoading] = useState(false);
  const [companyDataLoadError, setCompanyDataLoadError] = useState<any>(null);
  const hasFetchedRef = useRef(false);

  const fetchCompany = useCallback(async () => {
    if (hasFetchedRef.current) {
      return;
    }
    hasFetchedRef.current = true;
    setIsCompanyDataLoading(true);
    setCompanyDataLoadError(null);
    try {
      const response = await rmsApi.get('/api/v1/me');
      setCompanyData(response.data);
      onSuccess?.(response.data);
    } catch (error) {
      setCompanyDataLoadError(error);
      hasFetchedRef.current = false;
    } finally {
      setIsCompanyDataLoading(false);
    }
  }, [onSuccess]);

  return {
    companyData,
    isCompanyDataLoading,
    companyDataLoadError,
    fetchCompany
  };
};

export { useFetchCompanyData };
